import { SVGProps } from "react"

export const CheckMark = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
        <path
            d="M23 5L8.84727 19.1527C8.3103 19.6897 7.4397 19.6897 6.90273 19.1527L1 13.25"
            stroke="#111111"
            strokeLinecap="round"
        />
    </svg>
)
